import { render, staticRenderFns } from "./Liv.vue?vue&type=template&id=3d40c6ce&scoped=true"
import script from "./Liv.vue?vue&type=script&lang=js"
export * from "./Liv.vue?vue&type=script&lang=js"
import style0 from "./Liv.vue?vue&type=style&index=0&id=3d40c6ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d40c6ce",
  null
  
)

export default component.exports